<style>
.mobile-side-menu {
  position: fixed;
  top: 0; right: 0; bottom: 0;
  width: 70vw;
  background: #fff;
  z-index: 9999;
  box-shadow: -2px 0 8px rgba(0,0,0,0.1);
  animation: slideIn .2s;
}
.mobile-side-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 9998;
}
.mobile-side-content {
  padding: 40px 20px 20px 20px;
}
.mobile-side-close {
  position: absolute;
  top: 10px; right: 20px;
  font-size: 28px;
  cursor: pointer;
  color: #717171;
}
.mobile-side-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.mobile-side-content li {
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  font-size: 18px;
  cursor: pointer;
  color: #474747;
}
@keyframes slideIn {
  from { right: -70vw; }
  to { right: 0; }
}
  @media screen and (max-width: 1024px){
    .header{padding:0px!important;height:50px!important;}
    .menu{display:none!important}
    .header .logo-img{width:auto!important;height:35px!important;}
    
  }
  .mobile_menu {
  width: 32px;
  height: 32px;
  background-size: 24px 24px;
  display: none;
  position: absolute;
  right: 16px;
  top: 15px;
  z-index: 10000;
}
@media screen and (max-width: 1024px) {
  .mobile_menu {
    display: block !important;
  }
  .mobile-side-menu {
    display: block !important;
  }
  .menu {
    display: none !important;
  }
}
@media screen and (min-width: 1025px) {
  .mobile_menu,
  .mobile-side-menu {
    display: none !important;
  }
}

.mobile-side-content {
  position: relative;
  z-index: 10000;
  padding: 40px 20px 20px 20px;
  background: #fff;
  height: 100%;
}
  
  
</style>

<template>
  <header class="header">
    <a href="/"><img :src="BASE_URL + long.logo" class="logo-img" /></a>
    <div class="menu">
      <ul class="menu-item">
        <div class="menu-item-link active-route">
          <a href="/" aria-current="page" class="nuxt-link-exact-active nuxt-link-active">Trang chủ</a>
        </div>
      </ul>
      <ul class="menu-item">
        <div class="menu-item-link">
          <a href="/hotProducts" class="">Giới thiệu sản phẩm</a>
        </div>
      </ul>
      <ul class="menu-item">
        <div class="menu-item-link">
          <a href="/news" class="">Tin tức</a>
        </div>
      </ul>
      <ul class="menu-item">
        <div class="menu-item-link">
          <a href="/about" class="">Về Fast Charge</a>
        </div>
      </ul> 
      <select onchange="window.location.href=this.value;" style="height: 30px;margin-top: 26px;background: none;border: 1px solid #fff;color: #fff;">
        <option value="https://metfastcharge.net/"  style="background:#000">Tiếng Việt</option>  
        <option value="https://en.metfastcharge.net/" style="background:#000">English</option>
          <option value="https://jp.metfastcharge.net/" style="background:#000">Japanese</option>
          
      </select>
      
    </div>
    <div class="mobile_menu" v-if="!showMobileMenu" @click="showMobileMenu = true">
      <img src="/img/menu-icon.png" alt="menu" style="width:20px;height:20px;display:block;margin:auto;" />
    </div>
    <!-- Mobile right-side menu -->
    <div class="mobile-side-menu" v-if="showMobileMenu">
      <div class="mobile-side-mask" @click="showMobileMenu = false"></div>
      <div class="mobile-side-content">
        <div class="mobile-side-close" @click="showMobileMenu = false">×</div>
        <ul>
          <li @click="goPage('/')">Trang chủ</li>
          <li @click="goPage('/hotProducts')">Giới thiệu sản phẩm</li>
          <li @click="goPage('/about')">Về Fast Charge</li>
          <li @click="goPage('/news')">Tin tức</li>
          <li @click="goPage('/https://metfastcharge.net/')">Tiếng Việt</li>
        </ul>
        <select onchange="window.location.href=this.value;" style="height: 30px;margin-top: 26px;">
            <option value="https://metfastcharge.net/">Tiếng Việt</option>
            <option value="https://en.metfastcharge.net/">English</option>
            <option value="https://jp.metfastcharge.net/">Japanese</option>
            
        </select>
      </div>
    </div>
  </header>
</template>


<script>
  import { BASE_URL } from '@/config';
  export default {
  name: "vueHeader",
  props: {
    long: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      BASE_URL,
      showMobileMenu: false
    }
  },
  methods: {
    goPage(path) {
      this.showMobileMenu = false;
      this.$router.push(path);
    }
  },
  mounted() {
  const suspend = document.querySelector('.sd-suspend');
  if (suspend) {
    const icons = suspend.querySelectorAll('.icon-wrap');
    suspend.addEventListener('click', (e) => {
      const target = e.target.closest('.icon-wrap');
      if (target && suspend.contains(target)) {
        const form = suspend.querySelector('.form-input-class');
        const chat = suspend.querySelector('.chat-class');
        const follow = suspend.querySelector('.follow-class');
        const idx = Array.from(icons).indexOf(target);

        if (target.classList.contains('active')) {
          target.classList.remove('active');
          if (idx === 0 && form) form.style.display = 'none';
          if (idx === 1 && chat) chat.style.display = 'none';
          if (idx === 2 && follow) follow.style.display = 'none';
        } else {
          icons.forEach(el => el.classList.remove('active'));
          target.classList.add('active');
          if (form) form.style.display = 'none';
          if (chat) chat.style.display = 'none';
          if (follow) follow.style.display = 'none';
          if (idx === 0 && form) form.style.display = '';
          if (idx === 1 && chat) chat.style.display = '';
          if (idx === 2 && follow) follow.style.display = '';
        }
      }
    });

    // 监听 close-icon 点击，隐藏 form-input-class 并移除 icon-apply 的 active
    const close = suspend.querySelector('.close-icon');
    if (close) {
      close.addEventListener('click', () => {
        const form = suspend.querySelector('.form-input-class');
        if (form) form.style.display = 'none';
        const iconApply = suspend.querySelector('.icon-apply');
        if (iconApply) iconApply.classList.remove('active');
      });
    }

    // 监听 icon-backtop 点击，页面置顶
    const backtop = suspend.querySelector('.icon-backtop');
    if (backtop) {
      backtop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  // 页面加载时设置 lead-retention-class 初始状态
  const lead = document.querySelector('.lead-retention-class');
  if (lead) {
    if (window.scrollY > 400) {
      lead.style.display = '';
    } else {
      lead.style.display = 'none';
    }
  }

  // 滚动显示/隐藏 lead-retention-class
  window.addEventListener('scroll', () => {
    const lead = document.querySelector('.lead-retention-class');
    if (lead) {
      if (window.scrollY > 400) {
        lead.style.display = '';
      } else {
        lead.style.display = 'none';
      }
    }
  });
}
};
</script>
